import React from 'react';

const WorkingPatternsIcon = (props) => (
  <svg xmlns='http://www.w3.org/2000/svg' width='32' height='32' fill='none' {...props}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M14 17a4 4 0 1 0-4 4c-3.836 0-7 2.681-7 6.067 0 .515.423.933.944.933h12.112a.939.939 0 0 0 .944-.933C17 23.68 13.836 21 10 21a4 4 0 0 0 4-4Z'
      fill='currentColor'
    />
    <path
      d='M19.537 6.591a1 1 0 0 1 .993.883l.007.117v5.227l3.18 1.768a1 1 0 0 1 .44 1.255l-.051.105a1 1 0 0 1-1.255.44l-.105-.052-4.209-2.34V7.592a1 1 0 0 1 1-1Z'
      fill='currentColor'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M28 13a8 8 0 0 1-11.983 6.94 6.535 6.535 0 0 1-1.33 1.533A9.953 9.953 0 0 0 20 23c5.523 0 10-4.477 10-10S25.523 3 20 3c-4.478 0-8.268 2.943-9.542 7h.042c.685 0 1.346.106 1.966.303A8 8 0 0 1 28 13Z'
      fill='currentColor'
    />
  </svg>
);

export default WorkingPatternsIcon;
